import {Action, handleActions} from "redux-actions";
import {none, option} from "ts-option";
import {MerchantState} from "./MerchantState";
import {
	MERCHANT_CREATED,
	MERCHANT_SORT_ORDER_UPDATED,
	MERCHANT_UPDATED,
	MERCHANTS_FETCHED
} from "../../action/merchant/actionType";

const initState: MerchantState = {
	merchants: none,
};

const reducer = handleActions({
	[MERCHANTS_FETCHED]: (state: MerchantState, action: Action<any>): MerchantState => {
		return {...state, merchants: option(action.payload.merchants)}
	},
	[MERCHANT_CREATED]: (state: MerchantState, action: Action<MERCHANT_CREATED>): MerchantState => {
		return {
			...state, merchants: option(state.merchants.getOrElse([]).concat(action.payload.merchant))
		}
	},
	[MERCHANT_UPDATED]: (state: MerchantState, action: Action<MERCHANT_UPDATED>): MerchantState => {
		const merchants = state.merchants.getOrElse([]).map(
			m => m.id == action.payload.merchant.id ? action.payload.merchant : m);
		return {...state, merchants: option(merchants)}
	},
	[MERCHANT_SORT_ORDER_UPDATED]: (state: MerchantState, action: Action<MERCHANT_SORT_ORDER_UPDATED>): MerchantState => {
		return {...state, merchants: option(action.payload.merchants)};
	},
}, initState);

export default reducer;